/**
 * Application router.
 * Single source of truth for which pages are reachable. Only Home, About,
 * Contact and the 404 page are live; every other template page is intentionally
 * disabled (see the TODO blocks below) and any unknown path falls through to 404.
 */
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// ---------------------------------------------------------------------------
// ACTIVE PAGES
// For the initial launch we are only exposing Home, About and Contact.
// ---------------------------------------------------------------------------
import Homepage from '../HomePage';
import AboutPage from '../AboutPage';
import ContactPage from '../ContactPage';
import ErrorPage from '../ErrorPage';

// ---------------------------------------------------------------------------
// TEMPORARILY DISABLED PAGES
// These features are not ready for launch yet. To bring one back:
//   1. Uncomment its import below and its <Route> in the disabled block.
//   2. Add the link back to the header/footer navigation.
// Any request to these paths currently falls through to the 404 page.
//
// TODO: Re-enable when the alternate home layouts are needed.
// import Homepage2 from '../HomePage2'
// import Homepage3 from '../HomePage3'
// import Homepage4 from '../HomePage4'
//
// TODO: Re-enable when the Service section is ready.
// import ServicePage from '../ServicePage'
// import ServiceSinglePage from '../ServiceSinglePage'
//
// TODO: Re-enable when the Event section is ready.
// import EventPage from '../EventPage'
// import EventPageSingle from '../EventPageSingle'
//
// TODO: Re-enable when the Shop is ready.
// import ShopPage from '../ShopPage'
// import ShopSinglePage from '../ShopSinglePage'
//
// TODO: Re-enable when the Blog is ready.
// import BlogPage from '../BlogPage'
// import BlogPageLeft from '../BlogPageLeft'
// import BlogPageFullwidth from '../BlogPageFullwidth'
// import BlogDetails from '../BlogDetails'
// import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide'
// import BlogDetailsFull from '../BlogDetailsFull'
//
// TODO: Donations are deferred until a payment gateway is chosen. The interim
// plan is to point this at a Google Form ("register interest" — the team
// reaches back) before wiring up a real gateway in a future release.
// import DonatePage from '../DonatePage'

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="404" element={<ErrorPage />} />

          {/*
            TODO: Disabled routes — re-enable alongside the matching import above
            and the navigation links when each feature is ready to launch.

            <Route path='home2' element={<Homepage2/>} />
            <Route path='home3' element={<Homepage3/>} />
            <Route path='home4' element={<Homepage4/>} />
            <Route path='service' element={<ServicePage/>} />
            <Route path='service-single' element={<ServiceSinglePage/>} />
            <Route path='event' element={<EventPage/>} />
            <Route path='event-single' element={<EventPageSingle/>} />
            <Route path='shop' element={<ShopPage/>} />
            <Route path='shop-single' element={<ShopSinglePage/>} />
            <Route path='donate' element={<DonatePage/>} />
            <Route path='blog' element={<BlogPage/>} />
            <Route path='blog-left' element={<BlogPageLeft/>} />
            <Route path='blog-fullwidth' element={<BlogPageFullwidth/>} />
            <Route path='blog-details' element={<BlogDetails/>} />
            <Route path='blog-details-left' element={<BlogDetailsLeftSiide/>} />
            <Route path='blog-details-fullwidth' element={<BlogDetailsFull/>} />
          */}

          {/* Any unknown or disabled path is handled by the 404 page */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
